import React from 'react';
import T from 'prop-types';

import ChartLegend from '../../_render-chart/components/ChartLegend';

const UserStatistics = ({
  data,
  isMobileView,
}) => (
  <div className="user-statistics">
    <h1 className="title">{data.user_stats_header}</h1>
    <div className="charts">
      <div className="chart-box">
        <h2>{data.chart_title1}</h2>
        <div className="chart-image-legend-box ">
          <img
            src={data[isMobileView ? 'user_stats_chart_image_1_mobile' : 'user_stats_chart_image_1']}
            alt={data.chart_title1}
          />
          <ChartLegend options={data.chart_legend1} />
        </div>
      </div>
      <div className="chart-box">
        <h2>{data.chart_title2}</h2>
        <div className="chart-image-legend-box ">
          <img
            src={data[isMobileView ? 'user_stats_chart_image_2_mobile' : 'user_stats_chart_image_2']}
            alt={data.chart_title2}
          />
          <ChartLegend options={data.chart_legend2} />
        </div>
      </div>
    </div>
  </div>
);

UserStatistics.propTypes = {
  data: T.shape({
    user_stats_header: T.string,
    chart_title1: T.string,
    chart_title2: T.string,
    chart_legend1: T.array,
    chart_legend2: T.array,
    user_stats_chart_image_1: T.string,
    user_stats_chart_image_2: T.string,
    user_stats_chart_image_1_mobile: T.string,
    user_stats_chart_image_2_mobile: T.string,
  }).isRequired,
  isMobileView: T.bool.isRequired,
};

export default UserStatistics;
